<template>
  <div class="wrap1 flow-manger">
    <h2 class="common-title">{{ $t('work_rule_3') }}</h2>
    <el-scrollbar wrap-class="scrollbar-wrapper">
      <div class="wrap-content">
        <!-- 搜索栏 -->
        <div class="search">
          <div class="search-left">
            <el-input
              class="search-input"
              :placeholder="$t('69')"
              prefix-icon="el-icon-search"
              size="small"
              v-model="dataForm.keyWords"
            >
            </el-input>
            <el-button class="margin-left" type="primary" @click="handerGetData">{{ $t('69') }}</el-button>
          </div>
          <div class="search-right">
            <el-button
              @click="handleCreate({ type: 'create' })"
              :disabled="lang === 'id'"
              v-if="$p('menu.approval.config.edit')"
              >{{ $t('i18n.0f39f07d4c5a4a38a5c5d6148bf89926') }}</el-button
            >
            <el-button type="primary" @click="handleCreateFlow" v-if="$p('menu.approval.config.edit')">{{
              $t('i18n.ee6a2a33bf634ddba4ccdbaeca353f28')
            }}</el-button>
          </div>
        </div>
        <!-- 内容 -->
        <div class="content margin-top" v-if="groupsData.length" v-load="loadData">
          <div class="flow-class" v-for="(el, index) in groupsData" :key="index">
            <div class="flow-class-header">
              <h4>{{ el.groupName }}（{{ el.workFlowNums }}）</h4>
              <div>
                <el-tooltip
                  class="item"
                  effect="dark"
                  :content="$t('i18n.91e5ed17de904507abf36afe751c6285')"
                  placement="top"
                  v-if="$p('menu.approval.config.edit')"
                >
                  <i class="icon-button el-icon-edit-outline" @click="handleCreate({ type: 'edit', data: el })"></i>
                </el-tooltip>
                <el-tooltip
                  class="item"
                  effect="dark"
                  :content="el.workFlowList.length ? $t('74280164') : $t('i18n.578b3648f41c4b099e585e5390e48f0b')"
                  placement="top"
                  v-if="$p('menu.approval.config.delete')"
                >
                  <i
                    class="icon-button el-icon-delete margin-left el-link"
                    @click="handDelGroup(el)"
                    :class="{ 'el-link--default is-disabled': el.workFlowList.length }"
                  ></i>
                </el-tooltip>
              </div>
            </div>
            <!-- 表格列表 -->
            <div class="flow-class-content" v-if="el.workFlowList.length">
              <el-table class="flow-class-table" :data="el.workFlowList" empty-text=" ">
                <el-table-column prop="date">
                  <template slot-scope="{ row }">
                    <div class="flex-box" :class="{ 'stop-flow': row.deleted }">
                      <div class="icon-box" :style="{ background: row.icon.color }">
                        <i class="iconfont-2" :class="row.icon.name"></i>
                      </div>
                      <div class="explain-box">
                        <h4 class="icon-title ellipsis" :title="row.name">
                          {{ row.name }}
                          <span v-if="row.deleted" class="stop-flow-tag">{{ $t('1355') }}</span>
                        </h4>
                        <div class="visible-title ellipsis" :title="row.remark">{{ row.remark }}</div>
                      </div>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column prop="date">
                  <template slot-scope="{ row }">
                    <div :class="{ 'stop-flow': row.deleted }">
                      <h4 class="visible-title">{{ $t('i18n.bbf99ec01a0449de89061ca4562fb42f') }}</h4>
                      <span class="visible-text">{{ row.visible }}</span>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column prop="date">
                  <template slot-scope="{ row }">
                    <div :class="{ 'stop-flow': row.deleted }">
                      <h4 class="visible-title">{{ $t('work_rule_10') }}</h4>
                      <span class="visible-text">{{ row.updated_at }}</span>
                    </div>
                  </template>
                </el-table-column>
                <!-- 操作 -->
                <el-table-column prop="date" align="right">
                  <template slot-scope="{ row }">
                    <div style="padding-right: 10px">
                      <!-- 编辑审批流 -->
                      <el-tooltip
                        class="item"
                        effect="dark"
                        :content="$t('71')"
                        placement="top"
                        v-if="$p('menu.approval.config.edit')"
                      >
                        <i class="icon-button el-icon-edit-outline" @click="handleEditFlow(row)"></i>
                      </el-tooltip>
                      <el-tooltip
                        class="item"
                        effect="dark"
                        :content="$t('i18n.e1c1e0f8c212407490e186bd7a5b5f31')"
                        placement="top"
                        v-if="$p('menu.approval.config.edit')"
                      >
                        <i
                          class="icon-button el-icon-basketball margin-left el-link"
                          @click="handleEditLang(row)"
                          :class="{ 'el-link--default is-disabled': row.type !== 2 }"
                        ></i>
                      </el-tooltip>
                      <!-- 启用停用逻辑 -->
                      <template v-if="$p('menu.approval.config.delete')">
                        <el-tooltip class="item" effect="dark" :content="$t('137')" placement="top" v-if="row.deleted">
                          <i
                            class="icon-button el-icon-circle-check margin-left el-link el-link--success"
                            @click="handleEnable(row)"
                          ></i>
                        </el-tooltip>
                        <el-tooltip class="item" effect="dark" :content="$t('139')" placement="top" v-else>
                          <i
                            class="icon-button el-icon-circle-close margin-left el-link el-link--danger"
                            @click="handleEnable(row)"
                          ></i>
                        </el-tooltip>
                      </template>
                      <el-tooltip
                        class="item"
                        effect="dark"
                        :content="$t('65')"
                        placement="top"
                        v-if="row.deleted && $p('menu.approval.config.delete')"
                      >
                        <i class="icon-button el-icon-delete margin-left" @click="handleDelFlow(row)"></i>
                      </el-tooltip>
                    </div>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>
        </div>
        <!-- 搜索结果为空时 -->
        <el-empty
          class="el-empty"
          :image="require('@/assets/img/icon-not.png')"
          :description="$t('1c833418')"
          v-else
        ></el-empty>
      </div>
    </el-scrollbar>
    <createGroup v-if="createVisible" ref="create" @update="handleUpdate" />
    <createFlow v-if="createFlowVisible" ref="createFlow" :lang="lang" @update="handleUpdate" />
  </div>
</template>

<script>
import './style/index.scss'
import { utilCookies } from '@/util/cookies'
import createGroup from './components/createGroup'
import createFlow from './components/createFlow'
import { getWorkFlowList, delGroup, switchStatus } from '@/api/flow'
export default {
  components: {
    createGroup,
    createFlow
  },
  data() {
    const str = utilCookies.getLanguage()
    return {
      lang: str,
      loadData: false,
      createVisible: false,
      createFlowVisible: false,
      dataForm: {
        keywords: ''
      },
      loading: false,
      tableData: [],
      groupsData: []
    }
  },
  created() {
    this.handerGetData()
  },
  methods: {
    // 创建｜编辑分组
    handleCreate({ type, data }) {
      this.createVisible = true
      this.$nextTick(() => {
        this.$refs.create.init({
          type,
          data
        })
      })
    },
    // 创建审批流
    handleCreateFlow() {
      this.createFlowVisible = true
      this.$nextTick(() => {
        this.$refs.createFlow.init()
      })
    },
    // 是否刷新页面
    handleUpdate(isUpdate) {
      this.createVisible = false
      this.createFlowVisible = false
      isUpdate && this.handerGetData()
    },
    // 删除分组
    handDelGroup(group) {
      if (group.workFlowList.length) return false
      const $t = this.$t
      this.$confirm($t('i18n.82bede28c3184db19c6afbf59ea8a958'), $t('229'), {
        confirmButtonText: $t('65'),
        cancelButtonText: $t('66'),
        type: 'warning'
      }).then(async () => {
        delGroup(group).then(() => {
          this.handerGetData()
          this.$message.success(this.$t('806'))
        })
      })
    },
    // 编辑语言
    handleEditLang(row) {
      // 多语言配置仅支持自定义审批流
      if (row.type !== 2) return false
      this.$router.push({ path: '/approval/lang', query: { id: row.id } })
    },
    // 删除审批流
    handleDelFlow(flow) {
      const $t = this.$t
      this.$confirm($t('i18n.33fb3bc744cc4226bf97173df76b7f05'), $t('229'), {
        confirmButtonText: $t('65'),
        cancelButtonText: $t('66'),
        type: 'warning'
      }).then(async () => {
        switchStatus({ id: flow.id, deleted: 2 }).then(() => {
          this.handerGetData()
        })
      })
    },
    handleEditFlow(flow) {
      this.$router.push({
        path: '/approval/editSetting',
        query: { fid: window.btoa(flow.id), type: 'edit' }
      })
    },
    // 删除审批流
    handleEnable(flow) {
      // 0 启动。1停用 2 删除
      const $t = this.$t
      if (!flow.deleted) {
        this.$confirm($t('i18n.87a931eda6a14e13903b6f8c93f093be'), $t('229'), {
          confirmButtonText: $t('139'),
          cancelButtonText: $t('66'),
          type: 'warning'
        }).then(async () => {
          switchStatus({ id: flow.id, deleted: 1 }).then(() => {
            this.handerGetData()
          })
        })
      } else {
        switchStatus({ id: flow.id, deleted: 0 }).then(() => {
          this.handerGetData()
        })
      }
    },
    // 获取数据
    handerGetData() {
      this.loadData = true
      getWorkFlowList(this.dataForm)
        .then(res => {
          this.groupsData = res.data.items
        })
        .finally(() => (this.loadData = false))
    }
  }
}
</script>
